import { Flex, Tooltip, InfoButton, Text } from '@indeed/ifl-components';
import { Information } from '@indeed/ifl-icons';
import { HeadingComponentProps } from '../../types';

const Heading: React.FC<HeadingComponentProps> = ({
  text,
  tooltipText,
  tooltipLabel,
}) => {
  return (
    <Flex sx={{ mb: 3 }}>
      <Text
        level={4}
        sx={{ fontWeight: 'bold', mr: 1, color: 'foreground.strong' }}
      >
        {text}
      </Text>
      {tooltipText && (
        <Tooltip label={tooltipText} position="top">
          <InfoButton aria-label={tooltipLabel}>
            <Information aria-hidden size="sm" color="foreground" />
          </InfoButton>
        </Tooltip>
      )}
    </Flex>
  );
};

export default Heading;
